// MR Solutions — pt-BR copy for the immersive experience
export const content = {
  brand: "MR Solutions",
  scrollHint: "Role para explorar",
  cta: "Iniciar projeto",
  nav: [
    { label: "Início", p: 0.01 },
    { label: "Conceito", p: 0.22 },
    { label: "Soluções", p: 0.4 },
    { label: "Objetivo", p: 0.57 },
    { label: "Contato", p: 0.93 },
  ],
  frames: ["Identidade", "Conceito", "Soluções", "Objetivo", "Conexão", "Contato"],
  frame2: {
    tagline:
      "Transformamos suas ideias em soluções digitais modernas e eficientes para impulsionar o seu negócio.",
  },
  frame3: {
    kicker: "O que fazemos",
    text: "Desenvolvemos sites que ampliam o reconhecimento da sua empresa, entregando resultados eficientes por meio de soluções práticas.",
    browser: {
      url: "mrsolutions.com.br",
      menu: ["Início", "Sobre", "Serviços", "Contato"],
      cta: "Fale conosco",
      kicker: "Agência digital",
      heroTitle: "Soluções digitais para impulsionar seu negócio.",
      heroText:
        "Sites, sistemas e experiências sob medida para a sua marca crescer no digital.",
      heroBtn: "Saiba mais",
      sectionTitle: "Como podemos te ajudar",
      cards: [
        { title: "Web Design", desc: "Interfaces modernas e responsivas." },
        { title: "Desenvolvimento", desc: "Aplicações rápidas e escaláveis." },
        { title: "Performance", desc: "Otimização e resultados reais." },
      ],
    },
  },
  frame4: {
    title: "Nosso\nObjetivo",
    text: "Serviços de qualidade e excelência, promovendo maior destaque e reconhecimento no mercado digital.",
  },
  frame5: {
    kicker: "Alcance global",
    text: "Conectamos a sua marca ao mundo digital.",
  },
  frame6: {
    title: "Vamos conversar",
    subtitle: "Conte sobre o seu projeto e retornaremos em breve.",
    fields: { name: "Nome", email: "E-mail", message: "Mensagem" },
    placeholders: {
      name: "Seu nome",
      email: "voce@empresa.com",
      message: "Sobre o que você precisa?",
    },
    submit: "Enviar mensagem",
    footer: {
      tagline: "Soluções digitais que impulsionam o seu negócio.",
      links: ["Início", "Soluções", "Objetivo", "Contato"],
      copyright: "© 2026 MR Solutions. Todos os direitos reservados.",
    },
  },
};
